module.exports = __webpack_public_path__ + "media/images/vp/icon.rightarrow2.darkblue-ddb69b8bf49205c3fbbf021cca26fbbd.svg";